import { render, staticRenderFns } from "./DeliveryBoyList.vue?vue&type=template&id=0be93c50&"
import script from "./DeliveryBoyList.vue?vue&type=script&lang=js&"
export * from "./DeliveryBoyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports